import {StyleSheet} from 'react-native';
import {FontSizes, isPhone} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';
import {hoverLift, transition} from '@/Utils/motion';
import {radii} from '@/Utils/radius';

export const styles = StyleSheet.create({
  // Root Container for specific items (if needed) fallback
  wrapper: {
    width: '100%',
    paddingTop: 10,
    // marginBottom: 10,
  },

  // Generic / Promotional Banner Styles
  container: {
    flex: 1,
    borderRadius: radii.panel,
    backgroundColor: CCColors?.DashboardBanner?.Background,
    overflow: 'hidden',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: '6%',
    paddingVertical: 20,
    position: 'relative',
    marginHorizontal: 8,
    marginVertical: 8,
  },
  mobileContainer: {
    flex: 1,
    borderRadius: radii.panel,
    backgroundColor: CCColors?.DashboardBanner?.Background,
    overflow: 'hidden',
    position: 'relative',
    paddingVertical: 16,
    paddingLeft: 16,
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginHorizontal: 8,
    marginVertical: 8,
  },
  leftContent: {
    flex: 1,
    justifyContent: 'center',
    zIndex: 10,
  },
  mobileLeftContent: {
    width: '100%',
    zIndex: 10,
  },
  logoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  mobileLogoContainer: {
    justifyContent: 'space-between',
    width: '100%',
    paddingRight: 16,
  },
  logo: {
    width: isPhone ? 108 : 126,
    height: isPhone ? 24 : 28,
    resizeMode: 'contain',
  },
  title: {
    color: CCColors?.White,
    fontWeight: '700',
    marginBottom: 8,
  },
  mobileTitle: {
    fontSize: FontSizes[18],
  },
  tagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginBottom: 15,
  },
  tag: {
    color: CCColors?.White,
    fontSize: FontSizes[14],
    fontWeight: '500',
  },
  mobileTag: {
    fontSize: FontSizes[12],
  },
  tagSeparator: {
    color: CCColors?.White,
    marginHorizontal: isPhone ? 4 : 8,
  },
  bottomRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 24,
    marginTop: 10,
    marginBottom: 23,
  },
  mobileBottomRow: {
    flexWrap: 'wrap',
    marginTop: 20,
    width: '70%',
  },
  btnText: {
    color: CCColors?.DashboardBanner?.CtaText,
    fontWeight: '800',
    fontSize: FontSizes[14],
  },
  offerContainer: {
    flexDirection: 'column',
  },
  upToText: {
    color: CCColors?.DashboardBanner?.offerYellow,
    fontSize: FontSizes[12],
    fontWeight: '700',
  },
  offText: {
    color: CCColors?.DashboardBanner?.offerYellow,
    fontSize: FontSizes[24],
    fontWeight: '800',
  },
  couponContainer: {
    backgroundColor: CCColors?.White,
    borderWidth: 1,
    borderColor: CCColors?.OnboardingGrey,
    borderRadius: 6,
    padding: 2,
  },
  couponContainerInner: {
    backgroundColor: '#FFF5DC',
    borderWidth: 1,
    borderColor: '#26232233',
    borderStyle: 'dashed',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    borderRadius: 4,
    paddingVertical: 4,
    paddingHorizontal: 5,
  },
  couponText: {
    color: CCColors?.TextColor?.Dark,
    fontSize: FontSizes[14],
    fontWeight: '700',
    letterSpacing: 0.5,
  },
  girlImage: {
    right: 15,
    bottom: -17,
    width: 342,
    height: '100%',
    resizeMode: 'contain',
  },
  mobileGirlImage: {
    width: 127,
    height: 119,
    position: 'absolute',
    right: 0,
    bottom: 0,
  },

  // Feature Banner specifics
  subTitle: {
    color: '#FBBF24',
    fontSize: FontSizes[14],
    fontWeight: '700',
    marginBottom: 4,
    textTransform: 'uppercase',
  },
  checkmarksContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 16,
  },
  checkmarkRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
    marginRight: 10,
  },
  checkmarkText: {
    color: CCColors?.White,
    fontSize: FontSizes[12],
    marginLeft: 8,
  },
  chipsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 5,
  },
  chip: {
    backgroundColor: 'rgba(251, 191, 36, 0.2)',
    borderRadius: 100,
    paddingHorizontal: 14,
    paddingVertical: 5,
    borderWidth: 1,
    borderColor: 'rgba(251, 191, 36, 0.3)',
  },
  chipText: {
    color: '#FBBF24',
    fontSize: FontSizes[11],
    fontWeight: '600',
  },
  priceTextContainer: {
    marginRight: 15,
  },
  priceText: {
    color: CCColors?.Red || '#EF4444',
    fontWeight: 'bold',
    fontSize: FontSizes[14],
  },
  featureMainImageContainer: {
    position: 'absolute',
    right: '4%',
    top: 15,
    bottom: 15,
    width: 220,
    zIndex: 25,
  },
  featureMainImage: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
    borderWidth: 6,
    borderColor: '#FACC15',
    borderRadius: 36,
    zIndex: 30, // Stay above decorative overlapping pieces
  },
  overlappingPieceLeft: {
    position: 'absolute',
    left: -50,
    top: -30,
    width: 110,
    height: 140,
    resizeMode: 'contain',
    zIndex: 10,
    opacity: 0.15,
    tintColor: '#FFFFFF',
  },
  overlappingPieceRight: {
    position: 'absolute',
    right: -45,
    bottom: -35,
    width: 120,
    height: 160,
    resizeMode: 'contain',
    zIndex: 10,
    opacity: 0.15,
    tintColor: '#FFFFFF',
  },
  mobileFeatureMainImageContainer: {
    position: 'absolute',
    right: -20,
    bottom: -16,
    width: 145,
    height: 165,
    zIndex: 1,
  },
  mobileFeatureMainImage: {
    width: '100%',
    height: '100%',
    resizeMode: 'contain',
    zIndex: 20,
  },
  leftArrow: {
    position: 'absolute',
    left: 15,
    top: '50%',
    marginTop: -20,
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
  },
  rightArrow: {
    position: 'absolute',
    right: 15,
    top: '50%',
    marginTop: -20,
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
  },
  rightActionContainer: {
    position: 'absolute',
    right: '22%',
    top: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 20,
    paddingHorizontal: 10,
  },

  // Chess pieces background decoration
  chessPiecesOverlay: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    zIndex: 1,
    overflow: 'hidden',
  },
  chessPieceBg: {
    position: 'absolute',
    opacity: 0.08,
    resizeMode: 'contain',
    tintColor: '#FFFFFF',
  },

  // Feature banner top row: logo + badge
  featureTopRow: {
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 30,
    marginBottom: 20,
  },
  featureLogo: {
    width: 120,
    height: 24,
    resizeMode: 'contain',
  },
  subTitleBadge: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderRadius: 6,
    paddingHorizontal: 10,
    paddingVertical: 4,
    marginLeft: 12,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
  },
  subTitleBadgeText: {
    color: '#FBBF24',
    fontSize: FontSizes[11],
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },

  // Feature banner title (italic)
  featureTitle: {
    lineHeight: 26,
  },

  // Feature - price block on right side
  featurePriceBlock: {
    alignItems: 'center',
    marginBottom: 16,
    backgroundColor: '#FDE68A',
    borderRadius: 100,
    paddingHorizontal: 24,
    paddingVertical: 8,
    overflow: 'hidden',
    position: 'relative',
  },
  featurePriceStarting: {
    color: '#1F2937',
    fontSize: FontSizes[12],
    fontWeight: '800',
    letterSpacing: 1,
  },
  featurePriceAmount: {
    color: '#1F2937',
    fontSize: FontSizes[28],
    fontWeight: '900',
  },

  // Feature - enroll button
  featureEnrollBtn: {
    backgroundColor: '#EAB308', // Solid vivid gold
    borderRadius: 100, // pill
    paddingHorizontal: 28,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
  },
  featureEnrollBtnText: {
    color: '#1F2937',
    fontSize: FontSizes[14],
    fontWeight: '600',
    letterSpacing: 0.5,
  },

  // Daily Leaderboard promo slide
  leaderboardBanner: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#3F4B3E',
    borderRadius: radii.panel,
    paddingHorizontal: 20,
    paddingVertical: 16,
    gap: 12,
    // The gutter between slides. A carousel item is exactly the container
    // width, so without an inset here two slides touch edge-to-edge while one
    // is sliding out and the next in. 8 per side = a 16px gap mid-transition,
    // and lines the banner up with the hero card below (styles.card margin 8).
    marginHorizontal: 8,
  },
  leaderboardBannerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flex: 1,
  },
  infoSkeleton: {
    height: 80,
    borderRadius: radii.panel,
    backgroundColor: 'rgba(77,63,55,0.08)',
    // Matches the slide inset so the placeholder doesn't jump 8px when the
    // real banner replaces it.
    marginHorizontal: 8,
  },
  dotsRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 5,
    marginTop: 8,
  },
  dot: {
    height: 5,
    borderRadius: 99,
  },
  dotActive: {
    width: 16,
    backgroundColor: '#4D3F37',
  },
  dotIdle: {
    width: 5,
    backgroundColor: 'rgba(38,35,34,0.20)',
  },
  liveDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#FACF47',
  },
  leaderboardBannerIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255,255,255,0.15)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leaderboardBannerBtn: {
    backgroundColor: '#FACF47',
    borderRadius: 100,
    paddingHorizontal: 20,
    paddingVertical: 10,
    // Required so <Shine> is clipped to the pill.
    position: 'relative',
    overflow: 'hidden',
    ...transition(180),
  },
  leaderboardBannerBtnHovered: {
    backgroundColor: '#F5C21F',
    ...hoverLift(2),
    shadowColor: '#000',
    shadowOpacity: 0.3,
  },
  bannerBtnRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
  },
});
